import type { UUID } from "utils";

export const BASE_URL = "/transactions";

export const PAGE_URLS = {
  list: `${BASE_URL}`,
  details: `${BASE_URL}/:id`,
  notification: `${BASE_URL}/:id/notifications`,
  getLinkToDetails: (id: UUID) => `${BASE_URL}/${id}`,
  getLinkToNotifications: (id: UUID) => `${BASE_URL}/${id}/notifications`,
  getLinkToRefundDetails: (transactionId: UUID, refundId: UUID) =>
    `${BASE_URL}/${transactionId}/refunds/${refundId}`,
  getLinkToRefundCreate: (id: UUID) => `${BASE_URL}/${id}/refunds/new`,
  getLinkToRefundList: (transactionId: UUID) =>
    `/transactions/${transactionId}/refunds`,
  refundCreate: `${BASE_URL}/:id/refunds/new`,
  refundDetails: `${BASE_URL}/:id/refunds/:refundId`,
  refundsList: `${BASE_URL}/:id/refunds`,
  getLinkToTransactionRefunds: (id: UUID) => `${BASE_URL}/${id}/refunds`,
} as const;
